import { registerLocaleData } from '@angular/common';
import localeSl from '@angular/common/locales/sl';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

registerLocaleData(localeSl);

// Warm DNS/TCP/TLS to the API host so the first request (config, categories,
// ...) doesn't pay the handshake on the critical path.
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = new URL(environment.apiUrl).origin;
preconnect.crossOrigin = 'use-credentials'; // API calls use withCredentials: true
document.head.appendChild(preconnect);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
